import React from "react";

export const BulletList = ({ children }) =>
  <div className="ml-5">
    <ul>
      {children}
    </ul>
  </div>;